export const shouldShowFeatureNavigation = ({
  featureActive,
  freePlanActive,
  accessRestricted,
}: {
  featureActive: boolean;
  freePlanActive: boolean;
  accessRestricted: boolean;
}) => (featureActive && !freePlanActive) || accessRestricted;
